module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-site-baec9444da65788cb80c09f1869e3a93.svg";